import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router } from '@angular/router';
import { MatCardModule } from '@angular/material/card';

@Component({
    selector: 'app-terms',
    imports: [CommonModule, RouterModule, MatCardModule],
    templateUrl: './terms.component.html',
    styleUrls: ['./terms.component.scss']
})
export class TermsComponent {
  constructor(private router: Router) {}

  // Terms and conditions content
  showLoginFormOnHome() {
    console.log('Login form requested from navbar - navigating to home with login');
    this.router.navigate(['/'], { queryParams: { showLogin: 'true' } });
  }

  showTripSearchForm() {
    console.log('Trip search form requested from navbar - navigating to home');
    this.router.navigate(['/']);
  }
} 